import * as bootstrap from 'bootstrap';

const popupEl = document.getElementById('modal-popup');

if (popupEl) {
    const SESSION_KEY = 'oi_popup_shown';
    const popupModal = bootstrap.Modal.getOrCreateInstance(popupEl);

    popupEl.addEventListener('show.bs.modal', () => {
        sessionStorage.setItem(SESSION_KEY, '1');
    });

    window.addEventListener('load', () => {
        if (!sessionStorage.getItem(SESSION_KEY)) {
            popupModal.show();
        }
    });
}
